import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { getMemberSourceTranslationKey } from "@msuite/utils/calculations";
import { moment } from "@msuite/utils/date";
import type { CalculationMemberListItem } from "@msuite/utils/types";

const columnHelper = createColumnHelper<CalculationMemberListItem>();

export const columns = [
	columnHelper.accessor("_user.name", {
		header: localized("general.name"),
	}),
	columnHelper.accessor("source", {
		header: localized("general.source"),
		cell: (cell) => localized(getMemberSourceTranslationKey(cell.getValue())),
	}),
	columnHelper.accessor("createdAt", {
		header: localized("general_fields.created_at"),
		cell: (cell) => moment(cell.getValue()).dateFormat(),
	}),
];
